/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Injectable, NgZone } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { FirebaseApp } from '@angular/fire/compat';

/**
 * stores some of the things init'd early and makes accessible app wide.
 * Can safely assume that this will be populated as long as angular has initialized
 */
export let initEarlyGlobals: {
	ngZone: NgZone;
	angularfireAuth: AngularFireAuth;
} = { ngZone: null, angularfireAuth: null };

@Injectable({
	providedIn: 'root',
})
export class InitEarly {
	//note - the unused firebaseApp import is now apparently necessary for the app to build
	constructor(zone: NgZone, afAuth: AngularFireAuth, private firebaseApp: FirebaseApp) {
		initEarlyGlobals.ngZone = zone;
		initEarlyGlobals.angularfireAuth = afAuth;
	}
}
